/**
 * Check if a cookie exists.
 * @param {string} cookieToFind Wich cookie to look.
 * @return Boolean
 */
export const existCookie = (cookieToFind) => {
  const cookies = document.cookie.split(';');
  return cookies.filter((c) => c.split('=')[0].trim() === cookieToFind).length > 0;
};

/**
 * Encode a list of cookies to a valid Sandos format.
 * @param {array} cookieList Unidimensional Array of values to encode.
 * @return String
 */
export const encodeCookieList = (cookieList) => {
  const stringFormated = `['${cookieList.join("','")}']`;
  return encodeURI(stringFormated.replace(/'/g, '"'));
};

/**
 * Creates a cookie at the document.
 * @param {string} cookieName
 * @param {string} cookieValue
 * @param {string} [cookieExpireDate] When the cookie expires.
 * @param sameSiteOpt
 */
export const setCookie = (cookieName, cookieValue, cookieExpireDate, sameSiteOpt = 'strict') => {
  const cookieExpire = cookieExpireDate ? `expires=${cookieExpireDate.toUTCString()}` : '';
  const sameSite = `samesite=${sameSiteOpt}`;
  const domain = window.location.hostname.split('.').slice(-2).join('.');
  document.cookie = `${cookieName}=${cookieValue};${cookieExpire};${sameSite};domain=.${domain};path=/`;
};

/**
 * Check if a cookie exists.
 * @param {string} cookieToDelete Which cookie to delete.
 */
export const deleteCookie = (cookieToDelete) => {
  if (existCookie(cookieToDelete)) {
    const expireDate = new Date();
    expireDate.setDate(expireDate.getDate() - 100);
    const domain = window.location.hostname.split('.').slice(-2).join('.');
    document.cookie = `${cookieToDelete}=;expires=${expireDate};path=/;domain=${domain}`;
  }
};

/**
 * Get cookie value.
 * @param {string} cookieToGet Cookie name to get its value.
 * @return String
 */
export const getCookieValue = (cookieToGet) => {
  const cookies = document.cookie.split(';');
  return cookies.filter(
    (c) => c.split(
      '=')[0].trim() === cookieToGet)[0].trim().replace(`${cookieToGet}=`, '');
};
